import { lazy, type ComponentType } from "react";

const RELOAD_KEY = "chunk-reload-at";

/**
 * React.lazy wrapper that recovers from stale chunk hashes after a new deploy.
 * If a dynamic import fails, retry once, then force a single hard reload.
 */
export function lazyWithRetry<T extends ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>,
) {
  return lazy(async () => {
    try {
      return await factory();
    } catch (err) {
      try {
        return await factory();
      } catch {
        const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
        if (Date.now() - last > 10000) {
          sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
          window.location.reload();
          // If the reload is blocked (e.g. sandboxed preview frame), surface the error
          // to the error boundary instead of hanging forever on a blank screen.
          await new Promise((r) => setTimeout(r, 4000));
        }
        throw err;
      }
    }
  });
}